/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UserRoleEnum = 'DEALER' | 'MARKET_MANAGER' | 'SUPER_MARKET_MANAGER' | 'HQ' | 'ADMIN';

export const UserRoleEnum = {
    Dealer: 'DEALER' as UserRoleEnum,
    MarketManager: 'MARKET_MANAGER' as UserRoleEnum,
    SuperMarketManager: 'SUPER_MARKET_MANAGER' as UserRoleEnum,
    Hq: 'HQ' as UserRoleEnum,
    Admin: 'ADMIN' as UserRoleEnum
};

